import Headroom from 'headroom.js';

const init = () => {
    const header = document.querySelector("header");
 
    const headroom = new Headroom(header);
    headroom.init();    
}

export default {
    init
}